// export const base_url = `https://hrtest.jooodah.com`;
// export const uploads_url = `https://hrtest.jooodah.com/uploads/`;
// export const api_url = `https://hrtest.jooodah.com/api`;

// export const base_url = `https://api.governance.jooodah.com/`;
// export const uploads_url = `https://api.governance.jooodah.com/uploads`;
// export const api_url = `https://api.governance.jooodah.com/api`;

// export const base_url = `https://api.salesexecutive.jooodah.com/`;
// export const uploads_url = `https://api.salesexecutive.jooodah.com/uploads`;
// export const api_url = `https://api.salesexecutive.jooodah.com/api`;

export const base_url = `https://intermediateapi.jooodah.com/`;
export const uploads_url = `https://intermediateapi.jooodah.com/uploads`;
export const api_url = `https://intermediateapi.jooodah.com/api`;

// export const base_url = `https://api.traininganddevelopment.jooodah.com/`;
// export const uploads_url = `https://api.traininganddevelopment.jooodah.com/uploads`;
// export const api_url = `https://api.traininganddevelopment.jooodah.com/api`;
// export const base_url = `https://accounting.jooodah.com/`;
// export const uploads_url = `https://accounting.jooodah.com/uploads/`;
// export const api_url = `https://accounting.jooodah.com/api`;

// export const base_url = `https://convince.jooodah.com/`;
// export const uploads_url = `https://convince.jooodah.com/uploads/`;
// export const api_url = `https://convince.jooodah.com/api`;

// export const base_url = `https://dashboard.jooodah.com`;
// export const uploads_url = `https://dashboard.jooodah.com/uploads/`;
// export const api_url = `https://dashboard.jooodah.com/api`;

// export const base_url = `https://salesdashboard.jooodah.com`;
// export const uploads_url = `https://salesdashboard.jooodah.com/uploads/`;
// export const api_url = `https://salesdashboard.jooodah.com/api`;

export const sales_dashboard_url = `https://salesdashboard.jooodah.com`;
export const jooodah_dashboard_url = base_url;
